import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import HomePage from "./components/pages/Home";
import NotFoundPage from "./components/pages/NotFound";
import FactoryListPage from "./components/pages/FactoryList";
import FactoryDashboardPage from "./components/pages/Factory";

import "./App.css";

// Composant pour rediriger vers une URL externe
const ExternalRedirect = ({ url }) => {
  React.useEffect(() => {
    window.location.href = url;
  }, [url]);
  return null;
};

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route
            exact
            path="/dashboards/sales"
            render={() => (
              <ExternalRedirect url="https://back-office.cheerz.com/monitoring/metrics" />
            )}
          />
          <Route
            exact
            path="/dashboards/tech-server"
            render={() => (
              <ExternalRedirect url="https://back-office.cheerz.com/monitoring/servers" />
            )}
          />
          <Route
            exact
            path="/dashboards/factory/gennevilliers"
            render={() => (
              <ExternalRedirect url="https://back-office.cheerz.com/monitoring/factories/gennevilliers" />
            )}
          />
          <Route
            exact
            path="/dashboards/factory/cewe"
            render={() => (
              <ExternalRedirect url="https://back-office.cheerz.com/monitoring/factories/cewe" />
            )}
          />
          <Route
            path="/dashboards/factory"
            render={({ match: { url } }) => (
              <>
                <Route path={`${url}/`} component={FactoryListPage} exact />
                <Route path={`${url}/:factoryTag`} component={FactoryDashboardPage} />
              </>
            )}
          />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    );
  }
}

export default App;
